import React from 'react';

export default function MachineLogo() {
	return <img alt='machine' width='400' height='1366' src='/images/machine.png' />;
}
